import { Text, vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import type { ReactNode } from 'react';

interface CartSubSectionTitleAndCartRowProps {
  children: ReactNode;
  className?: string;
}

interface PriceProps {
  children: ReactNode;
  className?: string;
  isDiscount?: boolean;
  size?: string;
}

const cartSubSectionTitleStyles = css`
  margin-bottom: 2px;
`;

export const CartSubSectionTitle = ({
  children,
  className,
  ...rest
}: CartSubSectionTitleAndCartRowProps) => (
  <Text as="p" className={cx(cartSubSectionTitleStyles, className)} variant="16-bold" {...rest}>
    {children}
  </Text>
);

const cartRowStyles = css`
  display: flex;
  gap: 8px;
  justify-content: space-between;

  & > *:last-child:not(:first-child) {
    align-items: flex-end;
    display: flex;
    justify-content: flex-end;
    text-align: end;
  }
`;

export const CartRow = ({ children, className, ...rest }: CartSubSectionTitleAndCartRowProps) => (
  <span className={cx(cartRowStyles, className)} {...rest}>
    {children}
  </span>
);

const discountStyles = css`
  color: ${vars.colors.signal.positive.foreground};
  font-weight: 700;
`;

const largePriceStyles = css`
  font-size: 0.875rem;
`;

const xLargePriceStyles = css`
  font-size: 1.125rem;
  font-weight: 700;
`;

const priceStyles = (isDiscount: boolean | undefined, size: string | undefined) => css`
  flex-shrink: 0;
  margin-left: 1rem;
  ${isDiscount ? discountStyles : null};
  ${size === 'large' ? largePriceStyles : null};
  ${size === 'xlarge' ? xLargePriceStyles : null};

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 1rem;
  }
`;
export const Price = ({ children, className, isDiscount, size, ...rest }: PriceProps) => (
  <span className={cx(priceStyles(isDiscount, size), className)} {...rest}>
    {children}
  </span>
);
